module.exports = __webpack_public_path__ + "img/百香果7.a4fd4bb1.png";